import { render, staticRenderFns } from "./MyLuckDrawTicket.vue?vue&type=template&id=2670a945&scoped=true"
import script from "./MyLuckDrawTicket.vue?vue&type=script&lang=js"
export * from "./MyLuckDrawTicket.vue?vue&type=script&lang=js"
import style0 from "./MyLuckDrawTicket.vue?vue&type=style&index=0&id=2670a945&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2670a945",
  null
  
)

export default component.exports